import Manage from './manage'
import { connect } from 'react-redux'
import { getCampaignSelector } from 'redux/selectors/campaign'
import {
  contributorsMapSelector,
  pendingContributionsListSelector,
} from 'redux/selectors/contributions'
import { push } from 'react-router-redux'
import { glimpseRoute } from 'lib/route_utils'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const contributors = contributorsMapSelector(state, props)
  const pendingContributors = pendingContributionsListSelector(state, props)
  //  We take the withdraw amount off the moneybox immediately, so we don't need to count it in the pending amount.
  const pendingAmount =
    pendingContributors.reduce((sum, txn) => {
      return txn.withdraw ? sum : sum + txn.amount * 100
    }, 0) / 100

  return {
    title: campaign.title,
    hasChippedIn: campaign.current_value > 0,
    moneyboxAmount: campaign.moneybox_amount,
    hasMoneybox: campaign.moneybox_amount > 0,
    currencyCode: campaign.currency,
    contributorsCount: Object.keys(contributors).length,
    hasCurrencyBalance: campaign.has_currency_balance,
    pendingAmount,
    paypalDomain: state.geo.paypalDomain,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onTransfer() {
      dispatch(push({ pathname: glimpseRoute('edit', 'transfer') }))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Manage)
